import { render, staticRenderFns } from "./UserClaims.vue?vue&type=template&id=2832e5bf&"
import script from "./UserClaims.vue?vue&type=script&lang=js&"
export * from "./UserClaims.vue?vue&type=script&lang=js&"
import style0 from "./UserClaims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports